<template>
  <div>
    <!-- <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName='moduleName' ></AreaTree>
    </div> -->
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              clearable
              v-model="search.carNumber"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for>手机号:</label>
            <input
              clearable
              v-model="search.phone"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group">
            <label for="bdate">最后停车时间:</label>
            <el-date-picker
              clearable
              value-format="yyyy-MM-dd HH:mm:SS"
              @change="selectBeginDate"
              v-model="search.endDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </div>

          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <!-- <span class='add_btn'><button @click="addrOrEdit()" type="button" class="btn btn-default" id="addarea">添加</button></span> -->
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              导出
            </button>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="欠费车牌"
            prop="carNumber"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="注册号"
            prop="phone"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="现场收集"
            prop="orderPhone"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="欠费总金额"
            prop="total"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="追缴金额"
            prop="arrears"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="剩余欠费金额"
            prop="unpay"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="欠费次数" prop="num">
          </el-table-column>
          <!-- <el-table-column
            show-overflow-tooltip
            label="欠费开始时间"
            prop="crtTime"
          ></el-table-column> -->
          <el-table-column
            show-overflow-tooltip
            label="最后停车时间"
            prop="endDate"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="欠费开始时间"
            prop="crtTime"
          ></el-table-column>
        </el-table>
      </div>
      <!-- <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData.rows"
          height="100%"
          width="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column  show-overflow-tooltip label="车牌号" prop="plaId">
            <template
              slot-scope="scope"
            >{{!scope.row.plaId?'':JSON.parse(scope.row.plaId).carNumber}}</template>
          </el-table-column>
          <el-table-column  show-overflow-tooltip label="欠费金额" prop="realMoney"></el-table-column>
          <el-table-column  show-overflow-tooltip label="入场时间" prop="beginDate"></el-table-column>
          <el-table-column  show-overflow-tooltip label="离场时间" prop="endDate"></el-table-column>
          <el-table-column  show-overflow-tooltip label="订单号" prop="orderNum">
            <template slot-scope="scope">
							{{scope.row.parkingId?JSON.parse(scope.row.parkingId).parkingName:''}}
            </template>
          </el-table-column>
          <el-table-column  show-overflow-tooltip label="收费员" prop="chargeId">
            <template
              slot-scope="scope"
            >{{!scope.row.chargeId?'':JSON.parse(scope.row.chargeId).name}}</template>
          </el-table-column>

          <el-table-column  show-overflow-tooltip label="泊位号" prop="spaceId">
            <template
              slot-scope="scope"
            >{{!scope.row.spaceId?'':JSON.parse(scope.row.spaceId).spaceNum}}</template>
          </el-table-column>
        </el-table>
      </div> -->
    </div>

    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import { getOrderListFee, fetchPropertyList } from "@/api/url";

import Page from "../../commons/page";

// import Refresh from "../../commons/refresh.vue";

import AreaTree from "../../commons/areaTree";

export default {
  data() {
    return {
      // manager_btn_edit: false,
      // manager_btn_delete: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      // allOrderStatus: {},
      propertyList: [],
      moduleName: "parking",
      search: {
        pageNumber: 1,
        pageSize: 10,
        propertyId: null,
        carNumber: "",
        total: "",
        arrears: "",
        unpay: "",
        phone: "",
        endDate: [],
      },
      tableListData: {
        rows: [],
      },
      formLabelWidth: "100px",
      rules: {
        carNumber: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              // console.log(rule,value);
              if (value != "") {
                if (
                  /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/.test(
                    value
                  ) == false
                ) {
                  callback(new Error("车牌号输入有误"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写车牌号"));
              }
            },
          },
        ],
        userName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入车主",
          },
        ],
        // 手机号规则
        userPhone: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              // console.log(rule,value);
              if (value != "") {
                if (
                  /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
                    value
                  ) == false
                ) {
                  callback(new Error("请填写正确手机号"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写手机号"));
              }
            },
          },
        ],
      },
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      const { propertyId, carNumber, pageSize, phone, endDate } = this.search;
      this.$get(getOrderListFee(), {
        propertyId,
        limit: pageSize,
        page: curPage,
        carNumber: carNumber ? carNumber : null,
        phone: phone ? phone : null,
        beginDate: endDate?.[0] ?? null,
        endDate: endDate?.[1] ?? null,
      }).then((data) => {
        // if (data.status != 200) return;
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);

        _this.tableListData.rows = data.data.rows;
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      });
    },
    selectBeginDate(value) {
      console.log("date=>", value);
    },
    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    downloadData() {
      const { propertyId, carNumber, phone,endDate } = this.search;
      this.$downloadFileRequest(
        "/api/parking/parkingOrders/escapeFeeCarExport",
        {
          propertyId,
          carNumber: carNumber ? carNumber : null,
          phone: phone ? phone : null,
          beginDate: endDate?.[0] ?? null,
          endDate: endDate?.[1] ?? null,
        },
        "逃费车辆"
      );
    },
    getAllProperty() {
      return this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    async initProperty() {
      await this.getAllProperty();
      this.search.propertyId = this.propertyList[0].id;
      this.tableList(this.search.pageNumber);
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.manager_btn_edit = this.elements["manager:btn_edit"];
      this.manager_btn_delete = this.elements["manager:btn_delete"];
    },
  },
  components: {
    Page,
    // Refresh,
    AreaTree,
  },
  created: function() {
    this.permiss;
  },
  mounted: function() {
    this.initProperty();
  },
  watch: {
    elements: {
      handler: function(val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
};
</script>
<style scoped></style>
